"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueSpecialDto = exports.VenueSpecialVenueDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const VenueEventExternalLink_dto_1 = require("./VenueEventExternalLink.dto");
const EventDateRange_dto_1 = require("./EventDateRange.dto");
class VenueSpecialVenueDto {}
exports.VenueSpecialVenueDto = VenueSpecialVenueDto;
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialVenueDto.prototype, "logoUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialVenueDto.prototype, "mapLogoUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialVenueDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialVenueDto.prototype, "specials", void 0);
class VenueSpecialDto {}
exports.VenueSpecialDto = VenueSpecialDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: VenueSpecialVenueDto
}), __metadata("design:type", VenueSpecialVenueDto)], VenueSpecialDto.prototype, "venue", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueSpecialDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueSpecialDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueSpecialDto.prototype, "content", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "startDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "endDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "startTime", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "endTime", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "eventStartDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "eventEndDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  type: [EventDateRange_dto_1.EventDateRangeDto]
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "eventDateRanges", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "dayOfWeek", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "flyerUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "externalUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  type: VenueEventExternalLink_dto_1.VenueEventExternalLinkDto,
  required: false
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "externalLink", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "hideAddress", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "eventAddress", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueEventVisibility,
  required: false
}), __metadata("design:type", String)], VenueSpecialDto.prototype, "visibility", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'When true, tickets for this event can be purchased in the app.'
}), __metadata("design:type", Boolean)], VenueSpecialDto.prototype, "isTicketed", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false,
  description: 'Ticket price in cents (USD). Required when isTicketed is true.'
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "ticketPriceCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false,
  readOnly: true,
  description: 'Eventbrite event ID parsed from the external link. While set, the app sells tickets on Eventbrite first and the synced order RSVPs the user.'
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "eventbriteEventId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "rsvpedCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "commentCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "likeCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "likedByMe", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "commentedByMe", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "rsvpedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSpecialDto.prototype, "viewedAt", void 0);
//# sourceMappingURL=VenueSpecial.dto.js.map